
document.addEventListener("DOMContentLoaded", () => {
  console.log('loaded');
  const togglePasswordVisibilityButton = document.getElementById('togglePasswordVisibility');
  const customerPasswordInput = document.querySelector('.customer-password-field');

  togglePasswordVisibilityButton.addEventListener('click', (event) => {
    console.log('clicked');
    if (customerPasswordInput.type === "password") {
      customerPasswordInput.type = "text";
    } else {
      customerPasswordInput.type = "password";
    }
  });

});